import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ReportsService } from '../../../../core/services/reports.service';
import { ContainerReportDetail } from '../../../../core/models/container-report-general.model';
import { ContainerReportDetailComponent } from '../container-report-detail/container-report-detail.component';

@Component({
  selector: 'app-container-report-general',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    ContainerReportDetailComponent,
    RouterModule,
  ],
  templateUrl: './container-report-general.component.html',
  styleUrls: ['./container-report-general.component.scss'],
})
export class ContainerReportGeneralComponent implements OnInit {
  containerId!: number;
  reportDetail: ContainerReportDetail = {
    header: {
      id: 0,
      status: {
        id: 0,
        name: '',
      },
      container: {
        id: 0,
        nroSerie: '',
        client: {
          id: 0,
          rut: '',
          razonSocial: '',
        },
        containerType: {
          id: 0,
          name: '',
        },
        containerOwner: {
          id: 0,
          name: '',
        },
      },
      tara: '',
      lastPH: '',
    },
    maintenancesHistory: [],
    taraHistory: [],
    phHistory: [],
    gpHistory: [],
  };

  constructor(
    private route: ActivatedRoute,
    private reportService: ReportsService,
  ) {}

  ngOnInit(): void {
    this.containerId = +this.route.snapshot.paramMap.get('id')!;
    this.loadContainerReportDetail();
  }

  loadContainerReportDetail(): void {
    this.reportService
      .getReportContainerDetail(this.containerId)
      .subscribe((data: ContainerReportDetail) => {
        this.reportDetail = data;
      });
  }

  exportPdf(): void {
    this.reportService.getReportContainerDetailPdf(this.containerId).subscribe((blob: Blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `container_report_${this.containerId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
  }
}
